<template>
  <div class="basic_picture" @mouseenter="module_isHover(true)" @mouseleave="module_isHover(false)">
    <div class="tooptipPart all_tooptipPart">
      <template v-if="$store.state.app.view_pattern === 'pc'" class="module_edit_btn">
        <!-- <div class="styleContent lineControl" style="position:relative;" title="更换图片">
          <span class="el-icon-edit"></span>
          <my_img_cover
            :firstModel.sync="module.data.listArr.url"
            :is-edit-mode="Boolean(module.data.listArr.url)"
          ></my_img_co`ver>
        </div> -->
        <my_edit_btn :module="module" tabName="style"></my_edit_btn>
        <my_edit_btn :module="module" tabName="animation"></my_edit_btn>
        <my_link_btn :module="module"></my_link_btn>
        <my_close_btn :module="module" :column="column" :moduleIndex="module_index"></my_close_btn>
      </template>
    </div>
    <div
      class="my_picture animationBox"
      v-if="module.data.listArr.url"
      ref="animationBox"
      @mouseenter="(e) => { templet.enter_animation(this.img_effects, e.target, this.$store.state.app.view_pattern) }"
      @mouseleave="(e) => { templet.leave_animation(this.img_effects, e.target) }"
      :style="{
        borderRadius: module.data.pc_widgets_infor.borderRadius[module.data.pc_widgets_infor.borderRadius.radio_val].value + 'px'
      }"
    >
      <set_link class="linkPart" :sendData="module.data.listArr.link"></set_link>
      <img class="animationImg" :src="module.data.listArr.url"  :alt="module.data.listArr.summary"/>
    </div>
    <div v-else class="imgadd">
      <my_img_cover
        :firstModel.sync="module.data.listArr.url"
        :is-edit-mode="Boolean(module.data.listArr.url)"
      ></my_img_cover>
      <img :src="forMatImg().str1" />
    </div>
  </div>
</template>

<script>
import i18n from '../../language/index'
import imgadd from '@/assets/image/imgadd.jpg';
import imgadd_tc from '@/assets/image/imgadd_tc.jpg';
import imgadd_en from '@/assets/image/imgadd_en.jpg';

export default {
  name: 'basic_picture',
  data () {
    return {
      isHover: false,
      init_url: require('@/assets/image/imgadd.jpg'),
      imgadd,
      imgadd_tc,
      imgadd_en
    };
  },
  props: {
    module: {
      type: Object,
      default: null
    },
    column: {
      type: Object,
      default: null
    },
    row: {
      type: Object,
      default: null
    },
    module_index: {
      type: Number,
      default: 0
    }
  },
  computed: {
    img_effects () {
      return this.module.data.img_effects
    }
  },
  methods: {
    module_isHover (val) {
      this.isHover = val;
    },
    forMatImg() {
      let str1 = this.imgadd;
      if (this.$store.state.app.web_language_wm == 'en') {
        str1 = this.imgadd_en
      } else if(this.$store.state.app.web_language_wm == 'tc') {
        str1 = this.imgadd_tc
      }
      return { str1 }
    }
  },
  watch: {

  },
  mounted () {
    this.num = Math.random();
    this.templet.initImageAnimation(this.img_effects, this.img_effects, this.$refs.animationBox, this.$store.state.app.view_pattern)
  },
  created() {
    this.templet.checkSummaryValue(this.module.data.listArr)
    this.templet.checkBorderRadiusValue(this.module.data.pc_widgets_infor)
  }
};
</script>

<style lang="scss" scoped>
.basic_picture {
  .styleContent:hover {
    background-color: #2e343B;
  }
}
.my_picture img,
.imgadd img {
  display: block;
}
.imgadd {
  position: relative;
}
</style>



// WEBPACK FOOTER //
// src/widgets/basic_picture/index.vue